// extracted by mini-css-extract-plugin
export var noResultPage = "no-result-page_Vo09pGmXYAAvYcup4AyZ";
export var noResultPageDescription = "no-result-page__description_uu6sfeM4zdpY1pRK7xhp";